import React, { ReactNode, forwardRef } from "react";

interface ScrollbarProps {
  children: ReactNode;
  className?: string;
  maxHeight?: string;
}

/**
 * A reusable scrollbar component that:
 * - Shows a customized thin scrollbar on desktop (screens >= 768px)
 * - Hides the scrollbar entirely on mobile/tablet (screens < 768px)
 * - Is configured via the `md:custom-scrollbar` and `scrollbar-hide` utility classes.
 * Supports ref forwarding so parents can programmatically control scroll position.
 */
export const Scrollable = forwardRef<HTMLDivElement, ScrollbarProps>(
  ({ children, className = "", maxHeight = "100%" }, ref) => {
    return (
      <div
        ref={ref}
        className={`overflow-y-auto scrollbar-hide md:custom-scrollbar ${className}`}
        style={{ maxHeight }}
      >
        {children}
      </div>
    );
  },
);

Scrollable.displayName = "Scrollable";
